import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RadiusBottomleftOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusBottomleftOutlined";
import AntdIcon from "../components/AntdIcon";
var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusBottomleftOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
}
export default /*#__PURE__*/React.forwardRef(RadiusBottomleftOutlined);